<template>
  <div
    class="LeftDrawerContainer column"
    :class="{ closed: !opened }"
  >
    <div class="tld-header">
      <div class="tld-title ibf-h2">{{ title }}</div>
      <div
        :data-testid="elementIds.leftDrawer.close"
        class="tld-close-btn"
        @click="toggleld"
      >
        <q-icon name="west"></q-icon>
      </div>
    </div>
    <q-scroll-area
      :thumb-style="{ width: '3px', background: '#49DEAC', right: '11px', opacity: 1 }"
      style="width: 100%; flex-grow: 1"
      :content-active-style="{ height: '100%' }"
      :content-style="{ height: '100%' }"
    >
      <component
        :is="drawerComponent"
        v-if="opened"
        class="full-height column items-center"
      ></component>
    </q-scroll-area>
  </div>
</template>
<script>
import AgentTableFilters from '@/components/agents-table/components/AgentTableFilters/AgentTableFilters.vue';
import elementIds from '@/const/elementIds.json';

export default {
  name: 'LeftDrawer',

  components: {
    AgentTableFilters,
  },
  setup() {
    return { elementIds };
  },
  data() {
    return {};
  },
  computed: {
    drawerComponent() {
      return this.$store.getters['main/leftDrawerComponent'];
    },
    title() {
      return this.$store.getters['main/leftDrawerTitle'];
    },
    opened: {
      get() {
        return this.$store.getters['main/leftDrawer'] || false;
      },
      set(value) {
        this.$store.dispatch('main/SET_LD_STATE', value);
      },
    },
  },
  mounted() {
    this.$eventHub.$on('toggleLeftDrawer', this.toggleld);
    this.$eventHub.$on('closeLeftDrawer', this.closeld);
  },
  methods: {
    toggleld() {
      this.opened = !this.opened;
      // const state = this.opened;
      // this.$store.dispatch("main/SET_LD_STATE", state);
    },
    closeld() {
      this.opened = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.LeftDrawerContainer {
  margin-bottom: -80px;
  position: relative;
  top: -80px;
  position: relative;
  left: 0;
  min-width: 330px;
  background: $-system-app-white;
  border-right: 1px solid $-system-app-primary;
  margin-right: 0 !important;
  margin-left: 0 !important;
  transition: left 200ms cubic-bezier(0.82, 0.085, 0.395, 0.895), width 300ms cubic-bezier(0.82, 0.085, 0.395, 0.895);
  &.closed {
    min-width: unset;
    width: 0;
    left: -500px;
    transition: left 300ms cubic-bezier(0.82, 0.085, 0.395, 0.895), width 300ms cubic-bezier(0.82, 0.085, 0.395, 0.895);
  }

  .tld-header {
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px 10px 22px;
    background: url('@/assets/images/diagbg.png');
    background-repeat: no-repeat;
    background-size: 90% 100%;
    .tld-title {
      line-height: 33px;
      color: $-text--dark;
    }
    .tld-close-btn {
      color: $-system-app-white;
      background: $-text--dark;
      border-radius: 50%;
      height: 24px;
      width: 24px;
      font-size: 12px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .q-icon {
        font-size: 18px;
      }
    }
  }
}
</style>
